module.exports = __webpack_public_path__ + "img/icon-flag-black.81e80b17.svg";